import React, { Component } from 'react'
import { Scrollama, Step } from 'react-scrollama'
import { FormattedMessage } from 'react-intl';

import Cities from '../Cities/Cities'
import People from '../charts/PeopleChart/PeopleChartComponent'

const styles = {
  main: {
    //padding: '70vh 2vw',
    display: 'flex',
    fontFamily: 'Open Sans',
    justifyContent: 'space-between',
    position: 'relative',
  },
  /*test: {
    padding: 35,
    backgroundImage:
      `linear-gradient(to bottom,
        rgba(240, 255, 40, 1) 0%,
        rgba(240, 255, 40, 1) 100%),
      linear-gradient(to bottom,
        rgba(240, 40, 40, 1) 0%,
        rgba(240, 40, 40, 1) 100%)`,
    backgroundClip: 'content-box, padding-box',
  },*/
  btnContainer: {
    position: 'fixed',
  },
  btn: {
    padding: '8px 10px',
    fontSize: '14px',
    margin: '10px',
    fontFamily: 'Open Sans',
  },
  graphic: {
    flexBasis: '100%',
    position: 'sticky',
    /*position: '-webkit-sticky',
    position: '-moz-sticky',
    position: '-ms-sticky',
    position: 'sticky',
    position: '-webkit-sticky',*/
    width: '100%',
    //padding: '5rem 0',
    top: '0',
    alignSelf: 'flex-start',
    //backgroundColor: '#aaa',
    height: '100vh'
  },
  scroller: {
    pointerEvents: 'none',
    zIndex: 100,
    flexBasis: '45%',
  },
  step: {
    fontFamily: 'Open Sans', 
    color: 'black',
    margin: '2rem 2rem 2rem 2rem',
    textShadow: '-1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white, 1px 1px 0 white',
    paddingTop: 200,
    paddingBottom: 200,
    //border: '1px solid #333',
    pointerEvents: 'none',
  },
  p: {
    fontSize: 35, 
    fontFamily: 'Playfair Display', 
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    padding: '16px'
  },
  quoted: {
    borderLeftWidth: '5px',
    borderLeftColor: '#e2e2e2',
    borderLeftStyle: 'solid',
    paddingLeft: '16px'
  }
};

export default class BubbleCities extends Component {
  constructor(props) {
    super(props);
    this.state = { data: 0, width: 0, height: 0 };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  onStepEnter = ({ element, data }) => {
    //element.style.backgroundColor = 'lightgoldenrodyellow';
    this.setState({ data });
  };

  onStepExit = ({ element, data, direction }) => {
    if(this.state.data === 1 && direction === 'up' ) this.setState({ data: 0 });
    //element.style.backgroundColor = '#fff';
  };

  render() {
    const { data, height } = this.state;
    return (
      <div>
        <div>
          <div style={styles.main}>
            <div style={styles.scroller}>
              <Scrollama
                offset={0.33}
                onStepEnter={this.onStepEnter}
                onStepExit={this.onStepExit}
                //debug
              >
                <Step data={1}>
                  <div style={{...styles.step, height: '80vh' }}>
                    <div style={styles.p}>
                      <FormattedMessage id="app.bubbleCities1"/>
                    </div>
                  </div>
                </Step>
                <Step data={2}>
                  <div style={{...styles.step, height: '80vh' }}>
                    <div style={styles.p}>
                      <FormattedMessage id="app.bubbleCities2"/>
                    </div>
                  </div>
                </Step>
                <Step data={3}>
                  <div style={{...styles.step, height: '80vh' }}>
                    <div style={styles.p}>
                      <FormattedMessage id="app.bubbleCities3"/>
                    </div>
                    <h4 style={{...styles.quoted, paddingBottom: 16 }}><FormattedMessage id="app.bubbleCities4"/></h4>
                  </div>
                </Step>
                <Step data={4}>
                  <div style={{...styles.step, height: '100vh' }}>
                    <div style={styles.p}>
                      <FormattedMessage id="app.bubbleCities5"/>
                    </div>
                  </div>
                </Step>
                <Step data={5}>
                  <div style={{...styles.step, height: '100vh' }}>
                    <div style={styles.p}>
                      <FormattedMessage id="app.bubbleCities6"/>
                    </div>
                    <h4 style={{...styles.quoted, paddingBottom: 16 }}><FormattedMessage id="app.bubbleCities7"/></h4>
                  </div>
                </Step>
                <Step data={6}>
                  <div style={{...styles.step, height: '100vh' }}>
                    <div style={styles.p}>
                      <FormattedMessage id="app.bubbleCities8"/>
                    </div>
                  </div>
                </Step>
                <Step data={7}>
                  <div style={{...styles.step, height: '150vh' }}>
                    <div style={styles.p}>
                      <FormattedMessage id="app.bubbleCities9"/>
                    </div>
                  </div>
                </Step>
              </Scrollama>
            </div>
            <div style={{ position: 'absolute', top: 0, bottom: 0, width: '100%', }}>
              <div className="graphic">
                <div style={{ height: '100vh'}}>
                  {height && <Cities step={data} centered={data <= 1} zoomed={data >= 4} height={height}/>}
                </div>
              </div>
            </div>
            <div style={{ position: 'absolute', top: 0, bottom: 0, width: '100%' }}>
              <div className="graphic">
                <div style={{ height: '100vh' }}>
                  <div> 
                    { (height && data) >= 5 && <People step={data} height={height}/>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}